export const validationGenerics = [
    'genericStringRequired',
];
